module.exports = __webpack_public_path__ + "img/koh_voracious_appetite.ce379a52.png";